import { useListBrowserUtils } from '@ts-private/list-browser';
import { logsStore } from './EvaluationLogListBrowser';
import { useEffect } from 'react';

const useEvaluationLogFilters = () => {
  const { store, update } = useListBrowserUtils(logsStore);

  useEffect(() => {
    update(prev => {
      const hiddenFilters = [];
      if (!prev.filters.evaluationDate) hiddenFilters.push('evaluationTime');
      if (!prev.filters.evaluationEndDate) hiddenFilters.push('evaluationEndTime');
      return { ...prev, hiddenFilters };
    });
  }, [update, store.filters]);
};

export default useEvaluationLogFilters;
